// // // // // // import React from 'react'

// // // // // // function CultReligious() {
// // // // // //   return (
// // // // // //     <div>
      
// // // // // //     </div>
// // // // // //   )
// // // // // // }

// // // // // // export default CultReligious







// // // // // import React from "react";
// // // // // import {
// // // // //   BarChart,
// // // // //   Bar,
// // // // //   XAxis,
// // // // //   YAxis,
// // // // //   Tooltip,
// // // // //   Legend,
// // // // //   ResponsiveContainer,
// // // // //   LabelList,
// // // // // } from "recharts";

// // // // // const data = [
// // // // //   {
// // // // //     category: "Christianity",
// // // // //     LDS: 55,
// // // // //     Evangelical: 7,
// // // // //     Mainline: 6,
// // // // //     Catholic: 5,
// // // // //   },
// // // // //   {
// // // // //     category: "Unaffiliated",
// // // // //     Nothing: 18,
// // // // //     Atheist: 3,
// // // // //     Agnostic: 2,
// // // // //   },
// // // // //   {
// // // // //     category: "Non-Christian Faiths",
// // // // //     Islam: 1,
// // // // //     Buddhism: 1,
// // // // //     Hinduism: 0.5,
// // // // //     Judaism: 0.5,
// // // // //     Other: 1,
// // // // //   },
// // // // // ];

// // // // // function CultReligious() {
// // // // //   return (
// // // // //     <div className="w-full h-[500px] p-4 bg-white rounded shadow-md mt-[8rem]">
// // // // //       <h2 className="text-xl font-bold text-center mb-4">
// // // // //         Religious Affiliation in Utah (%)
// // // // //       </h2>
// // // // //       <ResponsiveContainer width="100%" height="100%">
// // // // //         <BarChart
// // // // //           data={data}
// // // // //           layout="vertical"
// // // // //           margin={{ top: 20, right: 30, left: 100, bottom: 20 }}
// // // // //         >
// // // // //           <XAxis type="number" domain={[0, 60]} />
// // // // //           <YAxis type="category" dataKey="category" />
// // // // //           <Tooltip />
// // // // //           <Legend />
// // // // //           {/* Christianity group */}
// // // // //           <Bar dataKey="LDS" stackId="a" fill="#6366f1">
// // // // //             <LabelList dataKey="LDS" position="right" />
// // // // //           </Bar>
// // // // //           <Bar dataKey="Evangelical" stackId="a" fill="#60a5fa" />
// // // // //           <Bar dataKey="Mainline" stackId="a" fill="#3b82f6" />
// // // // //           <Bar dataKey="Catholic" stackId="a" fill="#2563eb" />
// // // // //           {/* Unaffiliated group */}
// // // // //           <Bar dataKey="Nothing" stackId="b" fill="#10b981" />
// // // // //           <Bar dataKey="Atheist" stackId="b" fill="#059669" />
// // // // //           <Bar dataKey="Agnostic" stackId="b" fill="#047857" />
// // // // //           {/* Non-Christian group */}
// // // // //           <Bar dataKey="Islam" stackId="c" fill="#f59e0b" />
// // // // //           <Bar dataKey="Buddhism" stackId="c" fill="#f97316" />
// // // // //           <Bar dataKey="Hinduism" stackId="c" fill="#ef4444" />
// // // // //           <Bar dataKey="Judaism" stackId="c" fill="#dc2626" />
// // // // //           <Bar dataKey="Other" stackId="c" fill="#9d174d" />
// // // // //         </BarChart>
// // // // //       </ResponsiveContainer>
// // // // //     </div>
// // // // //   );
// // // // // }

// // // // // export default CultReligious;











// // // // import React from "react";
// // // // import {
// // // //   PieChart,
// // // //   Pie,
// // // //   Cell,
// // // //   Tooltip,
// // // //   ResponsiveContainer,
// // // //   Legend,
// // // // } from "recharts";

// // // // const COLORS = ["#6366f1", "#60a5fa", "#3b82f6", "#2563eb", "#94a3b8", "#0ea5e9"];

// // // // const christianityData = [
// // // //   { name: "LDS", value: 55 },
// // // //   { name: "Evangelical Protestant", value: 7 },
// // // //   { name: "Mainline Protestant", value: 6 },
// // // //   { name: "Catholic", value: 5 },
// // // //   { name: "Other Christian", value: 1 },
// // // // ];

// // // // const unaffiliatedData = [
// // // //   { name: "Nothing in particular", value: 18 },
// // // //   { name: "Atheist", value: 3 },
// // // //   { name: "Agnostic", value: 2 },
// // // // ];

// // // // const nonChristianData = [
// // // //   { name: "Islam", value: 1 },
// // // //   { name: "Buddhism", value: 1 },
// // // //   { name: "Hinduism", value: 0.5 },
// // // //   { name: "Judaism", value: 0.5 },
// // // //   { name: "Other World Religions", value: 1 },
// // // // ];

// // // // const renderChart = (title, data) => (
// // // //   <div className="w-full md:w-1/3 h-80 flex flex-col items-center mt-[25rem]">
// // // //     <h3 className="text-center font-semibold mb-2">{title}</h3>
// // // //     <ResponsiveContainer width="100%" height="100%">
// // // //       <PieChart>
// // // //         <Pie
// // // //           data={data}
// // // //           dataKey="value"
// // // //           nameKey="name"
// // // //           outerRadius={80}
// // // //           label
// // // //         >
// // // //           {data.map((entry, index) => (
// // // //             <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
// // // //           ))}
// // // //         </Pie>
// // // //         <Tooltip />
// // // //         <Legend />
// // // //       </PieChart>
// // // //     </ResponsiveContainer>
// // // //   </div>
// // // // );

// // // // export default function CultReligious() {
// // // //   return (
// // // //     <div className="flex flex-col md:flex-row justify-around items-center gap-6 p-4 bg-white rounded-md shadow-md">
// // // //       {renderChart("Christianity (73%)", christianityData)}
// // // //       {renderChart("Unaffiliated (22%)", unaffiliatedData)}
// // // //       {renderChart("Non-Christian Faiths (4%)", nonChristianData)}
// // // //     </div>
// // // //   );
// // // // }




// // // import React from 'react';
// // // import {
// // //   PieChart,
// // //   Pie,
// // //   Cell,
// // //   Tooltip,
// // //   Legend,
// // //   ResponsiveContainer
// // // } from 'recharts';

// // // const data = [
// // //   { name: 'LDS', value: 55, group: 'Christianity' },
// // //   { name: 'Evangelical Protestant', value: 7, group: 'Christianity' },
// // //   { name: 'Mainline Protestant', value: 6, group: 'Christianity' },
// // //   { name: 'Catholic', value: 5, group: 'Christianity' },
// // //   { name: 'Other Christian', value: 1, group: 'Christianity' },
// // //   { name: 'Nothing in particular', value: 18, group: 'Unaffiliated' },
// // //   { name: 'Atheist', value: 3, group: 'Unaffiliated' },
// // //   { name: 'Agnostic', value: 2, group: 'Unaffiliated' },
// // //   { name: 'Islam', value: 1, group: 'Non-Christian' },
// // //   { name: 'Buddhism', value: 1, group: 'Non-Christian' },
// // //   { name: 'Hinduism', value: 0.5, group: 'Non-Christian' },
// // //   { name: 'Judaism', value: 0.5, group: 'Non-Christian' },
// // //   { name: 'Other World Religions', value: 1, group: 'Non-Christian' },
// // // ];

// // // const COLORS = {
// // //   Christianity: '#60a5fa',     // blue
// // //   Unaffiliated: '#facc15',     // yellow
// // //   'Non-Christian': '#f87171'   // red
// // // };

// // // const getColor = (group) => COLORS[group] || '#ccc';

// // // function CultReligious() {
// // //   return (
// // //     <div className="w-full h-[500px]">
// // //       <h2 className="text-center text-2xl font-semibold mb-4 text-blue-800">
// // //         Religious Affiliation in Utah
// // //       </h2>
// // //       <ResponsiveContainer>
// // //         <PieChart>
// // //           <Pie
// // //             data={data}
// // //             dataKey="value"
// // //             nameKey="name"
// // //             cx="50%"
// // //             cy="50%"
// // //             outerRadius={150}
// // //             label={({ name, percent }) =>
// // //               `${name} (${(percent * 100).toFixed(1)}%)`
// // //             }
// // //           >
// // //             {data.map((entry, index) => (
// // //               <Cell
// // //                 key={`cell-${index}`}
// // //                 fill={getColor(entry.group)}
// // //               />
// // //             ))}
// // //           </Pie>
// // //           <Tooltip />
// // //           <Legend />
// // //         </PieChart>
// // //       </ResponsiveContainer>
// // //     </div>
// // //   );
// // // }

// // // export default CultReligious;








// // import React from 'react';
// // import {
// //   BarChart,
// //   Bar,
// //   XAxis,
// //   YAxis,
// //   Tooltip,
// //   Legend,
// //   ResponsiveContainer,
// //   LabelList
// // } from 'recharts';

// // const data = [
// //   {
// //     group: 'Christianity',
// //     LDS: 55,
// //     Evangelical: 7,
// //     Mainline: 6,
// //     Catholic: 5,
// //     OtherChristian: 1,
// //   },
// //   {
// //     group: 'Unaffiliated',
// //     Nothing: 18,
// //     Atheist: 3,
// //     Agnostic: 2,
// //   },
// //   {
// //     group: 'Non-Christian',
// //     Islam: 1,
// //     Buddhism: 1,
// //     Hinduism: 0.5,
// //     Judaism: 0.5,
// //     Other: 1,
// //   }
// // ];

// // const COLORS = {
// //   LDS: '#60a5fa',
// //   Evangelical: '#93c5fd',
// //   Mainline: '#3b82f6',
// //   Catholic: '#2563eb',
// //   OtherChristian: '#1d4ed8',
// //   Nothing: '#facc15',
// //   Atheist: '#fde047',
// //   Agnostic: '#ca8a04',
// //   Islam: '#f87171',
// //   Buddhism: '#fb923c',
// //   Hinduism: '#fbbf24',
// //   Judaism: '#ef4444',
// //   Other: '#f472b6'
// // };

// // function CultReligious() {
// //   return (
// //     <div className="w-full h-[500px] px-4 md:px-20 mt-[8rem]">
// //       <h2 className="text-center text-2xl font-semibold mb-6 text-blue-800">
// //         Religious Affiliation Breakdown in Utah
// //       </h2>
// //       <ResponsiveContainer width="100%" height="100%">
// //         <BarChart
// //           data={data}
// //           layout="vertical"
// //           margin={{ top: 20, right: 30, left: 100, bottom: 20 }}
// //         >
// //           <XAxis type="number" domain={[0, 100]} tick={{ fontSize: 12 }} />
// //           <YAxis dataKey="group" type="category" tick={{ fontSize: 14 }} />
// //           <Tooltip />
// //           <Legend wrapperStyle={{ fontSize: 12 }} />
// //           {Object.keys(COLORS).map((key) => (
// //             <Bar
// //               key={key}
// //               dataKey={key}
// //               stackId="a"
// //               fill={COLORS[key]}
// //               radius={[0, 4, 4, 0]}
// //             >
// //               <LabelList dataKey={key} position="inside" style={{ fill: 'white', fontSize: 10 }} />
// //             </Bar>
// //           ))}
// //         </BarChart>
// //       </ResponsiveContainer>
// //     </div>
// //   );
// // }

// // export default CultReligious;














// import React from 'react';
// import { Doughnut } from 'react-chartjs-2';
// import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js';

// ChartJS.register(ArcElement, Tooltip, Legend);

// const data = {
//   labels: [
//     'LDS',
//     'Evangelical',
//     'Mainline Protestant',
//     'Catholic',
//     'Other Christian',
//     'Nothing in particular',
//     'Atheist',
//     'Agnostic',
//     'Islam',
//     'Buddhism',
//     'Hinduism',
//     'Judaism',
//     'Other World Religions',
//   ],
//   datasets: [
//     {
//       label: 'Religious Affiliation',
//       data: [55, 7, 6, 5, 1, 18, 3, 2, 1, 1, 0.5, 0.5, 1],
//       backgroundColor: [
//         '#2563eb',
//         '#3b82f6',
//         '#60a5fa',
//         '#93c5fd',
//         '#1d4ed8',
//         '#facc15',
//         '#fbbf24',
//         '#f59e0b',
//         '#f87171',
//         '#fb923c',
//         '#f97316',
//         '#ef4444',
//         '#e879f9'
//       ],
//       borderColor: '#ffffff',
//       borderWidth: 2,
//       hoverOffset: 12, // gives a 3D hover effect
//     },
//   ],
// };

// const options = {
//   cutout: '40%', // makes it a doughnut
//   plugins: {
//     legend: {
//       position: 'right',
//       labels: {
//         font: {
//           size: 12
//         }
//       }
//     },
//     tooltip: {
//       callbacks: {
//         label: function (context) {
//           return `${context.label}: ${context.parsed}%`;
//         },
//       },
//     },
//   },
// };

// function CultReligious() {
//   return (
//     <div className="max-w-[800px] mx-auto p-4 mt-[7rem]">
//       <h2 className="text-center text-2xl font-semibold text-blue-800 mb-6">
//         Religious Affiliation in Utah (2024)
//       </h2>
//       <Doughnut data={data} options={options} />
//     </div>
//   );
// }

// export default CultReligious;









import React, { useEffect } from "react";
import * as am5 from "@amcharts/amcharts5";
import * as am5percent from "@amcharts/amcharts5/percent";
import am5themes_Animated from "@amcharts/amcharts5/themes/Animated";

function CultReligious() {
  useEffect(() => {
    let root = am5.Root.new("chartdiv");

    root.setThemes([am5themes_Animated.new(root)]);

    let chart = root.container.children.push(
      am5percent.PieChart.new(root, {
        layout: root.verticalLayout,
        innerRadius: am5.percent(30), // makes it a Doughnut
        radius: am5.percent(80),
      })
    );

    let series = chart.series.push(
      am5percent.PieSeries.new(root, {
        valueField: "value",
        categoryField: "category",
        alignLabels: true,
      })
    );

    series.slices.template.setAll({
      cornerRadius: 10,
      tooltipText: "{category}: {value}%",
    });

    series.data.setAll([
      { category: "LDS", value: 55 },
      { category: "Evangelical", value: 7 },
      { category: "Mainline Protestant", value: 6 },
      { category: "Catholic", value: 5 },
      { category: "Other Christian", value: 1 },
      { category: "Nothing in particular", value: 18 },
      { category: "Atheist", value: 3 },
      { category: "Agnostic", value: 2 },
      { category: "Islam", value: 1 },
      { category: "Buddhism", value: 1 },
      { category: "Hinduism", value: 0.5 },
      { category: "Judaism", value: 0.5 },
      { category: "Other World Religions", value: 1 },
    ]);

    return () => {
      root.dispose();
    };
  }, []);

//   return (
//     // <div className="max-w-[60vw] mx-auto p-4">
//     //   <h2 className="text-center text-2xl font-semibold text-[#ffc107] mb-6 ">
//     //     Religious Affiliation in Utah 
//     //   </h2>
//     //   <div className="-mr-[15rem]" id="chartdiv" style={{ width: "300%", height: "500px"}}></div>
//     // </div>



//     <div className="max-w-[60vw] mx-auto p-4">
//   <h2 className="text-center text-2xl font-semibold text-gray-700 mb-6">
//     Religious Affiliation in Utah
//   </h2>

//   <div className="flex items-start gap-4">
//     {/* Paragraph on the left */}
//     <p className=" flex justify-center text-justify items-center">
//       Slightly over half of all Utahns are Mormons, the vast majority of whom are members of the Church of Jesus Christ of Latter-day Saints (LDS Church), which has its world headquarters in Salt Lake City; Utah is the only state where a majority of the population belongs to a single church.
//     </p>

//     {/* Chart on the right */}
//     <div className="w-[500%]" id="chartdiv" style={{ height: "500px" }}></div>
//   </div>
// </div>


//  );


// return (
//   <div className="max-w-[60vw] mx-auto p-4">
//     <h2 className="text-center text-2xl font-semibold text-gray-700 mb-6">
//       Religious Affiliation in Utah
//     </h2>

//     <div className="flex gap-4">
//       {/* Paragraph on the left, vertically centered */}
    

//       {/* Chart on the right */}
//       <div className="w-[1000px]" id="chartdiv" style={{ height: "500px" }}></div>
//     </div>
//   </div>
// );


// return(
// <div className="max-w-screen-xl mx-auto p-4">
//   <h2 className="text-center text-2xl font-semibold text-gray-700 mb-6">
//     Religious Affiliation in Utah
//   </h2>

//   <div className="flex flex-col md:flex-row gap-6">
   
//     <div className="w-full md:w-[900px]" id="chartdiv" style={{ height: "400px" }}></div>
//   </div>
// </div>
// );


return (
  <div className="max-w-screen-xl mx-auto p-4">
    <h2 className="text-center text-2xl font-semibold text-gray-700 mb-6">
      Religious Affiliation in Utah
    </h2>

    <div className="flex flex-col md:flex-row gap-6">
      {/* Paragraph on the left, vertically centered on larger screens */}
      {/* <p className="self-center flex-1 text-justify text-gray-800">
        Slightly over half of all Utahns are Mormons, the vast majority of whom are members of the Church of Jesus Christ of Latter-day Saints (LDS Church), which has its world headquarters in Salt Lake City; Utah is the only state where a majority of the population belongs to a single church.
      </p> */}

      {/* Chart container with horizontal scroll on mobile */}
      <div className="w-full overflow-x-auto">
        <div
          className="min-w-[700px] md:w-[900px]"
          id="chartdiv"
          style={{ height: "400px" }}
        ></div>
      </div>
    </div>
  </div>
);


}

export default CultReligious;
